import React, { useEffect, useRef } from "react";
import { Alert, Box, Button, Typography } from "@mui/material";
import VerifiedUserRoundedIcon from "@mui/icons-material/VerifiedUserRounded";

export default function MercadoPago3DSChallenge({
  externalResourceUrl,
  creq,
  onComplete,
}) {
  const iframeName = useRef(`mp-3ds-${Math.random().toString(36).slice(2, 10)}`);
  const formRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.status === "COMPLETE") onComplete?.();
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onComplete]);

  useEffect(() => {
    const timer = window.setTimeout(() => formRef.current?.submit(), 50);
    return () => window.clearTimeout(timer);
  }, [externalResourceUrl, creq]);

  if (!externalResourceUrl || !creq) {
    return (
      <Alert severity="error">
        El banco solicitó una validación adicional, pero Mercado Pago no devolvió los datos necesarios.
      </Alert>
    );
  }

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <VerifiedUserRoundedIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 950 }}>
          Verificación de seguridad del banco
        </Typography>
      </Box>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        Completá la validación dentro del recuadro. El banco puede pedirte un código, una aprobación en la app o un dato adicional.
      </Typography>

      <Box
        component="iframe"
        name={iframeName.current}
        title="Verificación 3DS de la tarjeta"
        sx={{
          width: "100%",
          height: { xs: 460, sm: 600 },
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2.5,
          bgcolor: "#fff",
        }}
      />

      <Box
        component="form"
        ref={formRef}
        method="POST"
        action={externalResourceUrl}
        target={iframeName.current}
        sx={{ display: "none" }}
      >
        <input type="hidden" name="creq" value={creq} readOnly />
      </Box>

      <Button
        fullWidth
        variant="outlined"
        onClick={onComplete}
        sx={{ mt: 2, py: 1.2, borderRadius: 2, fontWeight: 900, textTransform: "none" }}
      >
        Ya completé la verificación
      </Button>
    </Box>
  );
}
